import { GroupsIcon, Table } from '@bp/ui-components';
import { FragmentType } from 'client/gql';
import { useTranslation } from 'react-i18next';
import { UseGroupsTableFragment, useGroupsTable } from '../hooks/useGroupsTable';
import { GroupTableType } from '../types/types';

type GroupsPreviewTableProps = {
  query: FragmentType<typeof UseGroupsTableFragment> | undefined;
  onNavigate: (uuid: string) => void;
};

export const GroupsPreviewTable = ({ query, onNavigate }: GroupsPreviewTableProps) => {
  const { t } = useTranslation();

  const { data, columns } = useGroupsTable({ query, showGroupInfo: true, columns: ['name'], onNavigate });

  return (
    <Table<GroupTableType>
      hideHeader
      customPadding='var(--spacing-6)'
      customRowHeight='var(--list-row-height)'
      customLastColSpacing='0'
      isDesktop={true}
      data={data}
      columns={columns}
      emptyStateSettings={{
        icon: <GroupsIcon className='svg-icon primary-light' />,
        size: 'small',
        title: '',
        subtitle: t('groups.noGroups'),
        padding: 'xl',
      }}
    />
  );
};
